import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ImageInfo, ItemPersonRelation, ItemSubType, ItemType, MainItemBasic } from '@irohalab/mira-sdk-angular';
import { DEFAULT_IMAGE_INFO, formatPublicTime, imageRatio } from '../utils';
import { NgClass } from '@angular/common';
import { UIResponsiveImageWrapper } from '@irohalab/deneb-ui';

interface ItemWithRelation {
  id: string;
  name?: string;
  nameCn?: string;
  type?: ItemType;
  subType?: ItemSubType;
  relationType?: string;
  coverImage: ImageInfo;
  imageRatio: number;
  publicTime: string;
}

const ALL_SELECTION = '全部';

@Component({
    selector: 'app-person-item-list',
    imports: [
    UIResponsiveImageWrapper,
    NgClass
],
    templateUrl: './person-item-list.component.html',
    styleUrl: './person-item-list.component.less'
})
export class PersonItemListComponent implements OnChanges {
  @Input()
  relatedMainItems!: MainItemBasic[];

  @Input()
  relations!: ItemPersonRelation[];

  itemsWithRelationMap: {[k: string]: ItemWithRelation[]} = {};
  relationTypeList: string[] = [];
  selectedRelationType!: string;

  get itemsWithRelation(): ItemWithRelation[] {
    if (this.selectedRelationType && this.selectedRelationType !== ALL_SELECTION) {
      return this.itemsWithRelationMap[this.selectedRelationType];
    } else if (this.selectedRelationType == ALL_SELECTION) {
      return Object.values(this.itemsWithRelationMap).reduce((prev, curr) => prev.concat(curr), []);
    } else {
      return [];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initializeItemsWithRelation();
  }

  selectRelationType(relationType: string): void {
    this.selectedRelationType = relationType;
  }

  private initializeItemsWithRelation(): void {
    if (this.relations?.length > 0 && this.relatedMainItems?.length > 0) {
      for (const relation of this.relations) {
        const mainItem = this.relatedMainItems.find(item => item.id === relation.mainItemId);
        if (mainItem) {
          let image = mainItem.coverImage ?? DEFAULT_IMAGE_INFO;
          const itemWithRelation = {
            id: mainItem.id,
            name: mainItem.name,
            nameCn: mainItem.nameCn,
            type: mainItem.type,
            subType: mainItem.subType,
            coverImage: image,
            imageRatio: imageRatio(image),
            publicTime: formatPublicTime(mainItem.publicTime),
            relationType: relation.relationType,
          }
          if (!this.itemsWithRelationMap[relation.relationType]) {
            this.itemsWithRelationMap[relation.relationType] = [];
          }
          this.itemsWithRelationMap[relation.relationType].push(itemWithRelation);
        }
      }
      this.relationTypeList = Object.keys(this.itemsWithRelationMap);
      if (this.relationTypeList.length > 0) {
        this.relationTypeList.unshift(ALL_SELECTION);
        this.selectedRelationType = ALL_SELECTION;
      }
    }
  }
}
